export default import.meta.ROLLDOWN_FILE_URL_InM82IDEXDTBlApwxnDLXg